import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformancePentad,
  setFilter,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';

export default function usePentad() {
  const pentad = useSelector(selectMeteorologyFieldsModelPerformancePentad);

  const setPentad = useCallback((value: string | undefined) => {
    store.dispatch(setFilter({ pentad: value }));
  }, []);

  return {
    pentad,
    setPentad,
  };
}
